import React, { useState, useEffect } from 'react';
import { Button, CssBaseline, TextField, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useLongPress } from 'use-long-press';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import { COLORS } from '../shared/Theme';
import { SIcon } from '../shared/Icon';
import { oper as v_oper, basic, Values, SNACKBAR_TIME } from '../request/values';
import ToastStr from '../request/toastStr';
import useCommonStyles from '../shared/commonStyles/headerEmpty/useCommonStyles';
import i18n, { setSavedLanguage } from '../locales';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	container: {
		padding: 0,
		height: '100vh',
		paddingTop: '15vh',
	},
	paper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	title: {
		width: '80%',
		alignItems: 'left',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '80%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		height: 60,
		margin: theme.spacing(3, 0, 2),
		borderRadius: '27px',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		border: 'solid 0.5px #cfd4d9',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		'&:hover': {
			backgroundColor: `${COLORS.WATER_BLUE}`,
		},
	},
	logoSection: {
		// position: 'absolute',
		// bottom: '5vh',
		// width: '100vw',
		// textAlign: 'center',
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		marginTop: '30vh',
	},
	logobutton: {
		border: 'none',
		backgroundColor: 'transparent',
	},
}));

const OperLoginIn: React.FC<any> = (props) => {
	const classes = useStyles();
	const commonClasses = useCommonStyles();
	const { t } = useTranslation('oper');

	const [email, setEmail] = useState<any | null>();
	const [password, setPassword] = useState<any | null>();
	const history = useHistory();
	const { enqueueSnackbar } = useSnackbar();

	const { setOper } = props;

	const handleLogin = (oper: any) => {
		console.log('in Login handleLogin', oper);
		if (oper) {
			if (oper.language === 'en') {
				console.log('en login');
				i18n.changeLanguage('en');
				setSavedLanguage('en');
				history.push({ pathname: '/operation/openClass' });
			} else {
				i18n.changeLanguage('ko');
				setSavedLanguage('ko');
				history.push({ pathname: '/operation/createClass' });
			}
		}
	};

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;

		if (id == 'email') setEmail(value);
		else setPassword(value);
	};

	const moveMember = () => {
		history.push('/');
	};

	const moveOperJoin = () => {
		window.location.href = 'https://educator.youstarter.co.kr/educator/signup';
	};

	const moveOperPassword = () => {
		history.push('/operation/password');
	};

	const submitHandler = (event: any) => {
		console.log('click submit');
		performLogin(email, password);
	};

	const performLogin = (email: any, password: any) => {
		axios({
			method: 'POST',
			data: {
				email: email,
				password: password,
			},
			withCredentials: true,
			url: SERVER + v_oper.oper + v_oper.login,

			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.LOGIN_FAIL, {
						variant: 'error',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else {
					setOper(data.oper);
					handleLogin(data.oper);
				}
			})
			.catch((error: any) => {
				if (error.response) {
					console.log('error?', error.response);
					if (error.response.status == 400) {
						enqueueSnackbar(ToastStr.LOGIN_FAIL, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else if (error.response.status === 401) {
						console.log(error.response.data.msg);
						if (error.response.data.msg === 'notApproved') {
							enqueueSnackbar(ToastStr.ID_APPROVE_FAIL_STR, {
								variant: 'warning',
								autoHideDuration: SNACKBAR_TIME,
							});
						} else {
							enqueueSnackbar(ToastStr.PWD_CHECK_FALSE_STR, {
								variant: 'error',
								autoHideDuration: SNACKBAR_TIME,
							});
						}
					}
				}
			});
	};

	const buttonToMem = useLongPress(moveMember, {
		threshold: 3000,
		captureEvent: true,
		cancelOnMovement: false,
	});

	useEffect(() => {
		const loginData = new URLSearchParams(window.location.search).get('login');

		if (loginData) {
			try {
				const [email, password] = decodeURIComponent(atob(loginData)).split('|');

				setEmail(email);
				setPassword(password);

				enqueueSnackbar('통합 로그인으로 자동 접속 중입니다...', {
					variant: 'success',
					autoHideDuration: SNACKBAR_TIME,
				});

				performLogin(email, password);

				window.history.replaceState({}, document.title, window.location.pathname);
			} catch (error) {
				console.error('login 데이터 복호화 실패', error);
				enqueueSnackbar('통합 로그인 정보가 올바르지 않습니다.', {
					variant: 'warning',
					autoHideDuration: SNACKBAR_TIME,
				});
			}
		}
	}, []);

	return (
		<div className={classes.background}>
			<Container component="main" className={classes.container}>
				<CssBaseline />
				<div className={classes.paper}>
					<div className={classes.title}>
						<div className={commonClasses.titleLeft}>
							{t('OperLogin.logo')}
							<br />
							{t('OperLogin.pageTitle')}
						</div>
					</div>

					<div className={classes.form}>
						<TextField
							variant="standard"
							margin="normal"
							required
							fullWidth
							id="email"
							label={t('OperLogin.email')}
							name="email"
							autoComplete="email"
							autoFocus
							value={email}
							onChange={valueChangeHandler}
							style={{ color: `${COLORS.charcoal_grey}` }}
							inputProps={{ 'data-testid': 'oper-login-email-input' }}
						/>
						<TextField
							variant="standard"
							margin="normal"
							required
							fullWidth
							name="password"
							label={t('OperLogin.password')}
							type="password"
							id="password"
							autoComplete="current-password"
							value={password}
							onChange={valueChangeHandler}
							style={{ color: `${COLORS.charcoal_grey}` }}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									submitHandler(e);
								}
							}}
							inputProps={{ 'data-testid': 'oper-login-password-input' }}
						/>
						<Button type="submit" fullWidth variant="contained" className={classes.submit} onClick={submitHandler} data-testid="oper-login-submit-btn">
							<Typography variant="h3">{t('OperLogin.loginButton')}</Typography>
						</Button>

						<Grid
							container
							justify="center"
							style={{
								flexDirection: 'column',
								textAlign: 'center',
								gap: '10px',
							}}
						>
							<Grid item>
								<Button onClick={() => moveOperJoin()}>
									<Typography variant="h2" style={{ color: `${COLORS.DOWN}` }}>
										{t('OperLogin.joinButton')}
									</Typography>
								</Button>
							</Grid>
							<Grid item>
								<Button onClick={() => moveOperPassword()}>
									<Typography
										style={{
											color: `${COLORS.DOWN}`,
											fontSize: '12px',
											textDecoration: 'underline',
										}}
									>
										{t('OperLogin.passwordButton')}
									</Typography>
								</Button>
							</Grid>
						</Grid>
					</div>
					<div className={classes.logoSection}>
						<button {...buttonToMem} className={classes.logobutton}>
							<SIcon type="P" />
						</button>
					</div>
				</div>
			</Container>
		</div>
	);
};

export default OperLoginIn;

/*
<div className={classes.logoSection}>
          <LongPressable
            onLongPress={() => moveMember()}
            longPressTime={3000}
          ><SIcon type="P" />
          </LongPressable>
        </div>
*/
